// Centralized storage keys and helpers for auth-related flags

export const TOKEN_KEY = 'token';
export const TOKEN_EXPIRY_KEY = 'authExpiry';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const LOGOUT_FLAG_KEY = 'goToLogout';

export const setLogoutFlag = () => {
  try {
    localStorage.setItem(LOGOUT_FLAG_KEY, 'true');
  } catch (_) {}
};

export const clearLogoutFlag = () => {
  try {
    localStorage.removeItem(LOGOUT_FLAG_KEY);
  } catch (_) {}
};

export const getLogoutFlag = () => {
  try {
    return localStorage.getItem(LOGOUT_FLAG_KEY);
  } catch (_) {
    return null;
  }
};
